module.exports = __webpack_public_path__ + "static/media/icono_levadura.178bb93a.svg";